<template>
    <Breadcrumbs main="Apps" title="Support Ticket" />
    <div class="container-fluid">
        <div class="row">

            <Card9 colClass="col-sm-12 " title="Support Ticket List" cardhaderClass="title-header" span="true" :spanClass="desc">
                <supportTicket />
                <supportTable />
            </Card9>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))
const supportTicket = defineAsyncComponent(() => import("@/components/theme/support/supportTicket.vue"))
const supportTable = defineAsyncComponent(() => import("@/components/theme/support/supportTable.vue"))
let desc = "List of ticket opend by customers"
</script>